import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ContentListItem, Heading, HeadingLevel, HeadingTag, Text, TextColor, TextTag, TextVariant, ToggleSwitch } from '@enbw/ui-react'
import styles from './styles.module.scss'
import { useAuth } from '@/application/auth/hooks/useAuth'
import { useAppStore } from '@/stores/useAppStore'
import { usePageTitle } from '@/application/routing/hooks/usePageTitle'

export const ProfilePage: FC = () => {
  const { t } = useTranslation()
  const auth = useAuth()
  const { isDarkMode, toggleMode, language } = useAppStore()

  usePageTitle(t('profile.pageTitle'))

  const handleColorSchemeChange = (event: Event): void => {
    if (event instanceof CustomEvent) {
      toggleMode()
    }
  }

  return (
    <>
      <Heading level={HeadingLevel.H1} tag={HeadingTag.H1}>
        {t('profile.title')}
      </Heading>
      <ContentListItem label={t('profile.name')} body={auth.name || t('common.unknown')} />
      <ContentListItem label={t('profile.email')} body={auth.email || t('common.unknown')} />
      <ContentListItem label={t('profile.roles')} body={auth.roles.length > 0 ? auth.roles.join(', ') : t('profile.noRoles')} />
      <ContentListItem label={t('profile.language')} body={t(`languages.${language}`)} />
      <ContentListItem label={t('profile.colorScheme')}>
        <div slot="body" className={styles.profileInfoRow}>
          <Text variant={TextVariant.BodyStandard} tag={TextTag.P} color={TextColor.Default}>
            {isDarkMode ? t('profile.darkMode') : t('profile.lightMode')}
          </Text>
          <ToggleSwitch checked={isDarkMode} onChange={handleColorSchemeChange} />
        </div>
      </ContentListItem>
    </>
  )
}
